import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u4E2D\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { ref, onMounted, reactive, onBeforeUnmount, nextTick } from 'vue';
import { useHomeStore } from "../../store/home"; //引入home仓库

import { storeToRefs } from 'pinia'; //引入方法让仓库里的值可以解构赋值并且具有响应式

import Manage from '@/pages/index/components/manage.vue';
import BannerSwiper from '@/components/BannerSwiper/index.vue';
import Advantage from '@/pages/index/components/advantage.vue';
import Media from '@/pages/index/components/media.vue';
import Mission from '@/pages/index/components/mission.vue';
import { useRouter, useRoute } from "vue-router";
import { getHomeSliderList_url } from '@/api'; //引入发送请求获取数据的方法

export default {
  components: {
    Manage: Manage,
    Advantage: Advantage,
    Media: Media,
    Mission: Mission,
    BannerSwiper: BannerSwiper
  },
  name: 'Index',
  setup: function setup() {
    var homeBannerList = reactive([{
      id: 0,
      // imageUrl: 'https://cdn.tenacia.com/base/tenacia-img/newBanner1.png',
      imageUrl: require('./images/newBanner1EN.jpg')
    }]); // const targetElement = ref(null);
    // const targetElementTwo = ref(null);
    // const targetElementThree = ref(null);
    // const observer = new IntersectionObserver((entries) => {
    //   entries.forEach((entry) => {
    //     if (entry.isIntersecting) {
    //       entry.target.classList.add('fadeIn'); // 添加 fadeIn 类名
    //     } else {
    //       // entry.target.classList.remove('fadeIn'); // 移除 fadeIn 类名
    //     }
    //   });
    // }, {
    //   threshold: 0.5, // 可以调整阈值来控制何时添加类名
    // });
    // let getHomeSliderList = getHomeSliderList_url()
    // if (getHomeSliderList.code == 200) {}

    var store = useHomeStore();
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store.getHomeSliderList();
              _context.next = 3;
              return nextTick();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))); // 在组件卸载前停止观察

    onBeforeUnmount( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return nextTick();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))); // let { homeBannerList } = storeToRefs(store) //从仓库获取数据

    var router = useRouter();
    var route = useRoute(); // let jumpAboutUs = ()=>{
    //   router.push({path:'/aboutUs'})
    // }
    // console.log(reactive(homeBannerList))

    return {
      // jumpAboutUs,
      homeBannerList: homeBannerList
    };
  }
};